import { render, staticRenderFns } from "./JobfairBox.vue?vue&type=template&id=4849b2fb&scoped=true"
import script from "./JobfairBox.vue?vue&type=script&lang=js"
export * from "./JobfairBox.vue?vue&type=script&lang=js"
import style0 from "./JobfairBox.vue?vue&type=style&index=0&id=4849b2fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4849b2fb",
  null
  
)

export default component.exports